<template>
  <footer class="bg6 p-t-45 p-b-45 p-l-45 p-r-45">
    <div class="flex-w">
      <div class="w-size6 p-t-30 p-l-15 p-r-15 respon3">
        <h4 class="s-text12 p-b-30">GET IN TOUCH</h4>

        <div>
          <p class="s-text7 w-size27">
            Any questions? Let us know in store at 8th floor, 379 Hudson St, New
            York, NY 10018 or call us on (+1) 96 716 6879
          </p>

          <div class="flex-m p-t-30">
            <a href="#" class="fs-18 color1 p-r-20 fa fa-facebook"></a>
            <a href="#" class="fs-18 color1 p-r-20 fa fa-instagram"></a>
            <a href="#" class="fs-18 color1 p-r-20 fa fa-pinterest-p"></a>
            <a href="#" class="fs-18 color1 p-r-20 fa fa-snapchat-ghost"></a>
            <a href="#" class="fs-18 color1 p-r-20 fa fa-youtube-play"></a>
          </div>
        </div>
      </div>

      <div class="w-size7 p-t-30 p-l-15 p-r-15 respon4">
        <h4 class="s-text12 p-b-30">Categories</h4>

        <ul>
          <li class="p-b-9">
            <a href="#" class="s-text7"> Men </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> Women </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> Dresses </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> Sunglasses </a>
          </li>
        </ul>
      </div>

      <div class="w-size7 p-t-30 p-l-15 p-r-15 respon4">
        <h4 class="s-text12 p-b-30">Links</h4>

        <ul>
          <li class="p-b-9">
            <a href="#" class="s-text7"> Search </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> About Us </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> Contact Us </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> Returns </a>
          </li>
        </ul>
      </div>

      <div class="w-size7 p-t-30 p-l-15 p-r-15 respon4">
        <h4 class="s-text12 p-b-30">Help</h4>

        <ul>
          <li class="p-b-9">
            <a href="#" class="s-text7"> Track Order </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> Returns </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> Shipping </a>
          </li>

          <li class="p-b-9">
            <a href="#" class="s-text7"> FAQs </a>
          </li>
        </ul>
      </div>

      <div class="w-size8 p-t-30 p-l-15 p-r-15 respon3">
        <h4 class="s-text12 p-b-30">Newsletter</h4>

        <form>
          <div class="effect1 w-size9">
            <input
              class="s-text7 bg6 w-full p-b-5"
              type="text"
              name="email"
              placeholder="email@example.com"
            />
            <span class="effect1-line"></span>
          </div>

          <div class="w-size2 p-t-20">
            <!-- Button -->
            <button class="flex-c-m size2 bg4 bo-rad-23 hov1 m-text3 trans-0-4">
              Subscribe
            </button>
          </div>
        </form>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
